import { Swiper, SwiperSlide } from 'swiper/react';
import { useTranslation, Trans } from 'react-i18next';
import 'swiper/css';

import img1 from '../../../assets/assets-home/img/crafted/1.webp';
import img2 from '../../../assets/assets-home/img/crafted/2.webp';
import img3 from '../../../assets/assets-home/img/crafted/3.webp';
import img4 from '../../../assets/assets-home/img/crafted/4.webp';

type CraftedService = { id: number; image: string; titleKey: string };

const services: CraftedService[] = [
    { id: 1, image: img1, titleKey: 'crafted.items.uhnw' },
    { id: 2, image: img2, titleKey: 'crafted.items.forbes' },
    { id: 3, image: img3, titleKey: 'crafted.items.familyOffices' },
    { id: 4, image: img4, titleKey: 'crafted.items.corporations' },
];

const CraftedCard = ({ service, className = '' }: { service: CraftedService; className?: string }) => {
    const { t, i18n } = useTranslation('home');
    const title = t(service.titleKey);
    const isRu = i18n.language === 'ru';
    const displayTitle = isRu && title
        ? title.charAt(0).toUpperCase() + title.slice(1)
        : title;
    return (
        <div className='lg:max-w-[262px] sm:max-w-[200px] max-w-[110px]'>
            <div className={`overflow-hidden ${className}`}>
                <img
                    src={service.image}
                    alt={displayTitle}
                    className="grayscale w-full h-full object-cover"
                />
            </div>

            <h5 className={`whitespace-pre-line text-center font-medium text-black text-xs mt-5 sm:text-xl sm:mt-[30px] lg:text-2xl lg:mt-[37px] ${isRu ? '' : 'capitalize'}`}>
                {displayTitle}
            </h5>
        </div>
    );
};

const CraftedSection = () => {
    return (
        <div className='lg:py-[60px] sm:py-10 py-8'>
            <h2 className="section-heading text-center mb-6 sm:mb-8 lg:mb-10 px-5 sm:px-6 lg:px-10">
                <Trans
                    i18nKey="crafted.heading"
                    ns="home"
                    components={{ br1: <br className='sm:hidden' /> }}
                />
            </h2>

            <div className="hidden lg:block">
                <div className="w-fit grid grid-cols-4 gap-4 lg:gap-8 justify-center mx-auto">
                    {services.map((service) => (
                        <CraftedCard
                            key={service.id}
                            service={service}
                            className="aspect-square max-w-[262px] rounded-[30px]"
                        />
                    ))}
                </div>
            </div>

            <div className="lg:hidden">
                <Swiper
                    slidesPerView="auto"
                    spaceBetween={16}
                    slidesOffsetBefore={20}
                    slidesOffsetAfter={20}
                    breakpoints={{
                        640: { spaceBetween: 20, slidesOffsetBefore: 24, slidesOffsetAfter: 24 },
                    }}
                    className="crafted-slider"
                >
                    {services.map((service) => (
                        <SwiperSlide key={service.id} style={{ width: 'auto' }}>
                            <CraftedCard
                                service={service}
                                className="w-[110px] h-[110px] rounded-[12px] sm:w-[200px] sm:h-[200px] sm:rounded-[23px]"
                            />
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default CraftedSection;
